import { render } from "./filterTabs.vue?vue&type=template&id=4faff1a5&scoped=true"
import script from "./filterTabs.vue?vue&type=script&lang=js"
export * from "./filterTabs.vue?vue&type=script&lang=js"

import "./filterTabs.vue?vue&type=style&index=0&id=4faff1a5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4faff1a5"]])

export default __exports__